import { render } from "./OrdenesView.vue?vue&type=template&id=7f278644"
import script from "./OrdenesView.vue?vue&type=script&lang=js"
export * from "./OrdenesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__